// extracted by mini-css-extract-plugin
export default {"root":"BrandIcon_root__1tfCt"};